module.exports = __webpack_public_path__ + "img/wechat.3a904bdd.svg";